import {
  Box,
  Flex,
  Spinner,
  useColorModeValue,
} from "@chakra-ui/react";

import MainDashboard from "App/DMRC/components/Dashboards/MainDashboard";
import IssueTable from "App/DMRC/components/Tables/IssueTable/IssueTable";
import OrderTable from "App/DMRC/components/Tables/OrderTable/OrderTable";
import ReconciliationTable from "App/DMRC/components/Tables/ReconciliationTable/ReconciliationTable";
import { AppContext } from "AppProvider/AppContext";
import { useContext } from "react";

import Footer from "./Footer";
import Main from "./Main";
import Navbar from "./Navbar";

import Users from "App/DMRC/components/Users/Users";
import CitiesTable from "App/DMRC/components/Map/CitiesTable";
import AdsTable from "App/DMRC/components/Ads/AdsTable";
import PaymentTable from "App/DMRC/components/Tables/PaymentTable/PaymentTable";
import SdkOrderTable from "App/DMRC/components/Tables/OrderTable/SdkOrderTable";
import CategoriesTable from "App/DMRC/components/Faqs/CategoriesTable";

type setActivePage = React.Dispatch<
  React.SetStateAction<string>
>;

type Page = {
  name: string;
  element: JSX.Element;
  appBar: boolean;
  permission?: string;
};

export default function MainWindow({
  activePage,
  setActivePage,
  displaySidebar,
  setDisplaySidebar,
  setOpenMobileSideDrawer,
}: {
  activePage: string;
  setActivePage: setActivePage;
  displaySidebar: boolean;
  setOpenMobileSideDrawer: any;
  setDisplaySidebar: React.Dispatch<
    React.SetStateAction<boolean>
  >;
}): JSX.Element {
  const { accountDetails } = useContext(AppContext);

  const page: Page[] = [
    {
      name: "Dashboard",
      element: <MainDashboard />,
      appBar: true,
    },
    {
      name: "Map",
      element: <CitiesTable />,
      appBar: true,
      permission: "canViewCities",
    },
    {
      name: "Ads",
      element: <AdsTable />,
      appBar: true,
    },
    {
      name: "Sdk Orders",
      element: <SdkOrderTable />,
      appBar: true,
    },
    {
      name: "Orders",
      element: <OrderTable />,
      appBar: true,
    },
    {
      name: "Reconciliation",
      element: <ReconciliationTable />,
      appBar: true,
    },
    {
      name: "Payment",
      element: <PaymentTable />,
      appBar: true,
    },
    {
      name: "Issues",
      element: <IssueTable />,
      appBar: true,
    },
    {
      name: "FAQs",
      element: <CategoriesTable />,
      appBar: true,
      permission: "canViewFaqs",
    },
    {
      name: "Users",
      element: <Users />,
      appBar: true,
    },
  ];

  const currentPage = () => {
    const currentPage = page.find(
      (p) => p.name === activePage
    );

    if (currentPage) {
      return <>{currentPage.element}</>;
    }

    return null;
  };

  return (
    <Flex
      bg={useColorModeValue(
        "gray.1000",
        "gray.500"
      )}
      direction="column"
      w="full"
    >
      <Navbar
        activePage={activePage}
        setActivePage={setActivePage}
        displaySidebar={displaySidebar}
        setDisplaySidebar={setDisplaySidebar}
        setOpenMobileSideDrawer={setOpenMobileSideDrawer}
      />
      {accountDetails ? (
        <>
          <Box
            w={{
              base: "100%",
              lg: displaySidebar ? `calc(100% - 6rem)` : "100%"
            }}
            ml={{
              base: "unset",
              lg: displaySidebar ? "6rem" : "0"
            }}
            transition="all 0.3s ease"
          >
            <Main>{currentPage()}</Main>
          </Box>

          {/* FOOTER */}

          <Footer />
        </>
      ) : (
        <Flex
          justifyContent="center"
          alignItems="center"
          p={6}
          // ps={12}
          // pe={12}
          minH="calc(100vh - 6rem)"
        >
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="teal.500"
            size="xl"
          />
        </Flex>
      )}
    </Flex>
  );
}